<div class="marketplace-container" (click)="closeDropdowns()">

  <!-- ==================== HERO SECTION ==================== -->
  <section class="hero-section">

    <img [src]="heroImage" alt="Hero Banner" class="hero-bg">
    <div class="hero-overlay"></div>

    <div class="hero-content">

      <!-- Back Button -->
      <button
        type="button"
        class="widowed-back-btn"
        (click)="goBack()"
        aria-label="Go back"
      >
        <span class="material-symbols-outlined">arrow_back</span>
      </button>

      <h1>{{ heroTitle }}</h1>
      <p>{{ heroSubtitle }}</p>

    </div>


    <!-- ==================== FLOATING SEARCH BOX ==================== -->
    <div
      class="hero-search-container"
      (click)="$event.stopPropagation()"
    >

      <div class="search-box">

        <!-- Category Dropdown -->
        <div
          class="search-field"
          (click)="toggleCategoryDropdown($event)"
        >

          <label>Search For Vendors</label>

          <div class="custom-select-trigger">
            <span>{{ selectedCategoryName }}</span>

            <span class="material-symbols-outlined">
              expand_more
            </span>
          </div>

          <div
            class="custom-options-menu"
            *ngIf="isCategoryOpen"
          >

            <div
              class="custom-option"
              (click)="selectCategory('', 'All Categories', $event)"
            >
              All Categories
            </div>

            <div
              class="custom-option"
              *ngFor="let cat of categories"
              (click)="selectCategory(cat._id, cat.name, $event)"
            >
              {{ cat.name }}
            </div>

          </div>

        </div>


        <!-- City Dropdown -->
        <div
          class="search-field"
          (click)="toggleCityDropdown($event)"
        >

          <label>Wedding city</label>

          <div class="custom-select-trigger">

            <span>
              {{ selectedCity || 'Select City' }}
            </span>

            <span class="material-symbols-outlined">
              expand_more
            </span>

          </div>


          <div
            class="custom-options-menu city-dropdown-menu"
            *ngIf="isCityOpen"
            (click)="$event.stopPropagation()"
          >

            <!-- City Search -->
            <div class="city-search-box">

              <input
                type="text"
                placeholder="Search city..."
                [(ngModel)]="searchCity"
                (click)="$event.stopPropagation()"
                autocomplete="off"
              >

            </div>


            <!-- Cities -->
            <div
              class="custom-option"
              *ngFor="let city of getFilteredCities()"
              [class.selected]="selectedCity === city.city_nme"
              (click)="selectCity(city.city_nme, $event)"
            >

              <span>
                {{ city.city_nme }}
              </span>

              <span
                class="material-symbols-outlined"
                *ngIf="selectedCity === city.city_nme"
              >
                check
              </span>

            </div>


            <!-- No Results -->
            <div
              class="no-city"
              *ngIf="getFilteredCities().length === 0"
            >
              No cities found
            </div>

          </div>

        </div>


        <!-- Search Button -->
        <button
          class="btn-search"
          (click)="searchVendors()"
        >
          Find vendors

          <span class="material-symbols-outlined">
            arrow_forward
          </span>
        </button>

      </div>

    </div>


    <!-- ==================== TOP RIGHT USER ACTIVITY BUTTONS ==================== -->
    <div class="hero-top-nav">

      <!-- My Bookings -->
      <button
        type="button"
        class="btn-activity"
        routerLink="/wedding-services/booking-details"
      >

        <span class="material-symbols-outlined">
          event_available
        </span>

        <span class="btn-activity-text">
          My Bookings
        </span>

      </button>


      <!-- My Enquiries -->
      <button
        type="button"
        class="btn-activity"
        routerLink="/wedding-services/enquiries"
        style="position: relative;"
      >

        <span class="material-symbols-outlined">
          forum
        </span>

        <span class="btn-activity-text">
          My Enquiries
        </span>


        <!-- Unread Count -->
        <span
          *ngIf="unreadEnquiriesCount > 0"
          class="enquiry-badge"
        >
          {{ unreadEnquiriesCount }}
        </span>

      </button>


      <!-- Shortlisted Merchants -->
      <button
        type="button"
        class="btn-activity"
        routerLink="/wedding-services/shortlisted-merchants"
      >

        <span class="material-symbols-outlined">
          favorite
        </span>

        <span class="btn-activity-text">
          Shortlisted Merchants
        </span>

      </button>

    </div>

  </section>


  <!-- ==================== POPULAR CATEGORIES ==================== -->
  <section class="popular-categories">

    <div class="section-header">

      <h2>
        Popular Wedding Services
      </h2>

      <p>
        Discover top-rated professionals for your big day
      </p>

    </div>


    <div
      class="category-grid"
      *ngIf="!loading"
    >

      <div
        class="category-card"
        *ngFor="let category of categories"
        (click)="openCategory(category)"
      >

        <div class="card-img-wrapper">

          <img
            [src]="category.image"
            alt="{{category.name}}"
            class="cat-img"
            *ngIf="category.image"
          >

          <div
            class="cat-icon-fallback"
            *ngIf="!category.image"
          >

            <span class="material-symbols-outlined">
              {{category.icon}}
            </span>

          </div>

        </div>


        <div class="card-info">

          <h5>
            {{category.name}}
          </h5>

          <span class="vendor-count">
            {{ vendorCounts[category._id] || 0 }} Vendors
          </span>

        </div>

      </div>

    </div>


    <!-- Loading -->
    <div
      class="loading-state"
      *ngIf="loading"
    >

      <div class="spinner"></div>

      <p>
        Loading premium vendors...
      </p>

    </div>

  </section>


  <!-- ==================== LEAD GENERATION CTA ==================== -->
  <section class="lead-gen-cta mt-5 mb-5">

    <div class="cta-container">

      <div class="cta-content">

        <div class="text-group">

          <h2>
            Hustle in search?
          </h2>

          <p>
            Just fill in your details, and our best vendors will reach out
            to you with personalized quotes!
          </p>

        </div>


        <button
          class="btn-cta"
          routerLink="/wedding-services/lead/post-requirement"
        >
          Get Free Quotes
        </button>

      </div>


      <div class="cta-image">

        <img
          src="https://images.unsplash.com/photo-1511285560929-80b456fea0bc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80"
          alt="Wedding Planning"
        >

      </div>

    </div>

  </section>


  <!-- ==================== FEATURED VENDORS ==================== -->
  <section class="featured-vendors">

    <div class="section-header">

      <h2>
        Top Rated Vendors
      </h2>


      <button
        class="view-all-btn"
        (click)="openAllPremiumVendors()"
      >
        View All
      </button>

    </div>


    <div
      class="vendor-carousel"
      *ngIf="premiumVendors.length > 0"
    >

      <div
        class="vendor-card"
        *ngFor="let vendor of premiumVendors"
      >

        <div class="vendor-image">

          <img
            [src]="vendor.image"
            [alt]="vendor.name"
          >


          <span class="premium-badge">

            <span class="material-symbols-outlined">
              star
            </span>

            {{vendor.badge}}

          </span>


          <button class="wishlist-btn">

            <span class="material-symbols-outlined">
              favorite_border
            </span>

          </button>

        </div>


        <div class="vendor-details">

          <div class="title-row">

            <h3>
              {{vendor.name}}
            </h3>


            <div class="rating">

              <span class="material-symbols-outlined star-icon">
                star
              </span>

              <strong>
                {{vendor.rating}}
              </strong>

              ({{vendor.reviews}})

            </div>

          </div>


          <p class="location">

            <span class="material-symbols-outlined">
              location_on
            </span>

            {{vendor.location}}

          </p>


          <div class="price-row">

            <div class="price">

              <span class="label">
                Category
              </span>

              <strong>
                {{vendor.category}}
              </strong>

            </div>


            <button
              class="btn-book"
              [routerLink]="[
                '/wedding-services/merchant',
                vendor.id
              ]"
            >
              Book Now
            </button>

          </div>

        </div>

      </div>

    </div>

  </section>


  <!-- ==================== PREMIUM ADVERTISEMENT ==================== -->
  <section
    class="premium-ad-banner"
    *ngIf="activeAds.length > 0"
  >

    <div class="slideshow-container">

      <div
        class="ad-slide"
        *ngFor="let ad of activeAds; let i = index"
        [class.active]="i === currentAdIndex"
        [style.backgroundImage]="getAdBackground(ad)"
      >

        <div class="ad-content-split">


          <!-- Shop Image -->
          <div
            class="shop-image-container"
            *ngIf="ad.profile_pic"
          >

            <img
              [src]="getProfilePicUrl(ad)"
              alt="Vendor Profile"
              class="shop-full-image"
            >


            <div class="shop-name-overlay">

              <span class="ad-label">
                Sponsored Vendor
              </span>

              <h3 class="shop-name">
                {{ ad.business_name }}
              </h3>

            </div>

          </div>


          <!-- Offer Details -->
          <div class="offer-details">

            <h2>
              {{ ad.advertisement.title || 'Exclusive Offer' }}
            </h2>

            <p>
              {{ ad.advertisement.text }}
            </p>


            <div class="ad-actions">

              <div
                class="promo-code"
                *ngIf="ad.advertisement.code"
              >
                Use Code:

                <strong>
                  {{ ad.advertisement.code }}
                </strong>

              </div>


              <button
                class="btn-white"
                (click)="goToMerchantProfile(ad._id)"
              >
                View Vendor
              </button>

            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- Slideshow Dots -->
    <div
      class="slideshow-dots"
      *ngIf="activeAds.length > 1"
    >

      <span
        class="dot"
        *ngFor="let ad of activeAds; let i = index"
        [class.active]="i === currentAdIndex"
        (click)="currentAdIndex = i"
      ></span>

    </div>

  </section>


  <!-- ==================== WEDDING PACKAGES ==================== -->
  <section class="wedding-packages">

    <div class="section-header">

      <h2>
        Wedding Packages
      </h2>

      <p>
        Tailored experiences for every budget
      </p>

    </div>


    <div class="packages-grid">

      <div
        class="package-card"
        *ngFor="let pkg of weddingPackages"
      >

        <div class="pkg-icon">

          <span class="material-symbols-outlined">
            {{pkg.icon}}
          </span>

        </div>

        <h4>
          {{pkg.title}}
        </h4>

        <p>
          {{pkg.description}}
        </p>

        <a
          href="#"
          class="pkg-link"
        >
          Explore Package
        </a>

      </div>

    </div>

  </section>


  <!-- ==================== WHY WEDDINGLY ==================== -->
  <section class="why-weddingly">

    <div class="section-header">

      <h2>
        Why Choose Weddingly?
      </h2>

    </div>


    <div class="features-grid">

      <div
        class="feature-item"
        *ngFor="let feature of whyWeddingly"
      >

        <div class="feature-icon">

          <span class="material-symbols-outlined">
            {{feature.icon}}
          </span>

        </div>

        <h4>
          {{feature.title}}
        </h4>

        <p>
          {{feature.description}}
        </p>

      </div>

    </div>

  </section>


  <!-- ==================== TESTIMONIALS ==================== -->
  <section class="testimonials">

    <div class="section-header">

      <h2>
        What Couples Say
      </h2>

    </div>


    <div class="testimonial-grid">

      <div
        class="review-card"
        *ngFor="let review of testimonials"
      >

        <div class="stars">

          <span
            class="material-symbols-outlined"
            *ngFor="let i of [1,2,3,4,5]"
          >
            star
          </span>

        </div>


        <p class="review-text">
          "{{review.review}}"
        </p>


        <h5 class="couple-name">
          - {{review.name}}
        </h5>

      </div>

    </div>

  </section>


  <!-- ==================== FAQ ==================== -->
  <section class="faq-section">

    <div class="section-header">

      <h2>
        Frequently Asked Questions
      </h2>

    </div>


    <div class="faq-list">

      <div
        class="faq-item"
        *ngFor="let faq of faqs; let i = index"
        [class.open]="faq.open"
      >

        <div
          class="faq-question"
          (click)="toggleFaq(i)"
        >

          <h4>
            {{faq.question}}
          </h4>

          <span class="material-symbols-outlined">
            {{ faq.open ? 'remove' : 'add' }}
          </span>

        </div>


        <div
          class="faq-answer"
          *ngIf="faq.open"
        >

          <p>
            {{faq.answer}}
          </p>

        </div>

      </div>

    </div>

  </section>


  <!-- ==================== FINAL CTA ==================== -->
  <section class="final-cta">

    <h2>
      Are you a wedding vendor?
    </h2>

    <p>
      Join India's premium wedding planning platform and grow your business.
    </p>

    <button class="btn-primary-large">
      Become a Vendor
    </button>

  </section>


  <!-- ==================== ALL PREMIUM VENDORS MODAL ==================== -->
  <div
    class="premium-modal-backdrop"
    *ngIf="showAllPremiumModal"
    (click)="closeAllPremiumVendors()"
  >

    <div
      class="premium-modal"
      (click)="$event.stopPropagation()"
    >


      <!-- Modal Header -->
      <div class="premium-modal-header">

        <div>

          <h2>
            Premium Vendors
          </h2>

          <p>
            Discover our premium wedding professionals
          </p>

        </div>


        <button
          class="modal-close"
          (click)="closeAllPremiumVendors()"
        >

          <span class="material-symbols-outlined">
            close
          </span>

        </button>

      </div>


      <!-- Premium Vendors -->
      <div class="premium-vendor-grid">

        <div
          class="premium-vendor-card"
          *ngFor="let vendor of allPremiumVendors"
          (click)="goToMerchantProfile(vendor.id)"
        >


          <div class="vendor-image">

            <img
              [src]="vendor.image"
              [alt]="vendor.name"
            >

            <span class="premium-badge">
              Premium
            </span>

          </div>


          <div class="vendor-info">

            <h3>
              {{ vendor.name }}
            </h3>


            <div class="vendor-rating">

              <span class="material-symbols-outlined">
                star
              </span>

              {{ vendor.rating }}

              <span class="review-count">
                ({{ vendor.reviews }})
              </span>

            </div>


            <div class="vendor-location">

              <span class="material-symbols-outlined">
                location_on
              </span>

              {{ vendor.location }}

            </div>


            <div class="vendor-category">
              {{ vendor.category }}
            </div>

          </div>

        </div>

      </div>


      <!-- No Vendors -->
      <div
        class="no-premium-vendors"
        *ngIf="allPremiumVendors.length === 0"
      >

        <p>
          No premium vendors available.
        </p>

      </div>

    </div>

  </div>

</div>